import { html, LitElement, TemplateResult } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { UrlValidator as validateUrl } from "@slhuicore/utils";
import DOMPurify from "dompurify";

/**
 * @customElement slh-nav-banner
 */
@customElement("slh-nav-banner")
export default class SlhNavigationBanner extends LitElement {
  /**
   * Path for configured banner
   */
  @property({
    type: String,
  })
  url?: string;

  @query(".banner-holder", false)
  bannerHolder: HTMLElement | undefined;

  protected firstUpdated(): void {
    this.assertValidUrl();
    if (this.url) {
      fetch(this.url)
        .then((response) => response.text())
        .then((result) => {
          if (this.bannerHolder) {
            this.bannerHolder.innerHTML = DOMPurify.sanitize(result);
          }
        })
        .catch((error) => {
          console.error(
            "[slh-nav-banner] An error has occurred while fetching banner: ",
            error,
          );
        });
    }
  }

  private assertValidUrl(): void {
    if (this.url === "" || !validateUrl(this.url)) {
      console.error(
        "[slh-nav-banner] Valid URL must be provided to fetch navigation banner",
      );
    }
  }

  /**
   * @returns render html template
   */

  render(): TemplateResult {
    return html`<div class="banner-holder"></div>`;
  }
}
